import state from './moduleFundingsState.js'
import mutations from './moduleFundingsMutations.js'
import actions from './moduleFundingsActions.js'
import getters from './moduleFundingsGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
